<template>
  <section class="back-to-shop">
    <p v-if="showTimer" role="timer" aria-atomic="true">{{ $t('confirmation.linkBackTimeout') }} {{redirectTime}} {{ $t('confirmation.linkBackTimeoutTime') }}</p>
    <button type="button"
            ref="backButton"
            class="btn button-back-to-shop"
            :title="$t('confirmation.linkBack')"
            @click="supportButtonBackClick">
      {{ returnText }}
    </button>
    <input type="hidden" style="margin: 10px;" id="iframefocus" value="">
  </section>
</template>

<script>
import { ToolsClass } from '@/base/class/tools.class'
import { MobileAppClass } from '@/base/class/mobileApp.class'
import {
  MATOMO_EVENT_CATEGORY,
  MATOMO_EVENT_TYPE
} from '@/base/const/matomo.const'
import { MatomoClass } from '@/base/class/matomo.class'
import { mapGetters, mapMutations, mapState } from 'vuex'
import redirectTimerMixin from '@/base/mixins/redirectTimer.mixin'

export default {
  name: 'PartnerReturnBtn',
  mixins: [redirectTimerMixin],
  props: {
    returnText: {
      type: String,
      required: true
    },
    returnUrl: {
      type: String,
      required: true
    },
    showTimer: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  watch: {
    isCommercialBreakClosed: function (val) {
      if (val) {
        this.goBackToShop()
      }
    }
  },
  computed: {
    ...mapState({
      isCommercialBreakClosed: state => state.ads.commercialBreakClosed
    }),
    ...mapGetters({
      isCommercialBreakDataSet: 'isCommercialBreakDataSet'
    })
  },
  methods: {
    ...mapMutations([
      'SET_ADS_SHOW_COMMERCIAL_BREAKE'
    ]),
    supportButtonBackClick () {
      this.sendEventButtonClickToMatomo()
      this.goBackToShop()
    },
    goBackToShop () {
      this.stopRedirectTimeout()
      if (this.isCommercialBreakDataSet && !this.isCommercialBreakClosed) {
        this.SET_ADS_SHOW_COMMERCIAL_BREAKE(true)
        return
      }
      if (ToolsClass.isMobileAppConnection()) {
        MobileAppClass.callMobileTransactionFinish()
        return
      }
      ToolsClass.goToExternalUrl(this.returnUrl)
    },
    sendEventButtonClickToMatomo () {
      const event = [
        MATOMO_EVENT_TYPE.trackEvent,
        MATOMO_EVENT_CATEGORY.experiments,
        'trackThankYouPageButtonBackClick'
      ]
      MatomoClass.sendEvent(event)
    },
    sendEventButtonViewToMatomo () {
      const event = [
        MATOMO_EVENT_TYPE.trackEvent,
        MATOMO_EVENT_CATEGORY.experiments,
        'trackThankYouPageButtonBackView'
      ]
      MatomoClass.sendEvent(event)
    }
  },
  mounted () {
    if (this.showTimer) {
      this.initRedirectTimer()
    }
    this.sendEventButtonViewToMatomo()
  },
  beforeDestroy () {
    this.destroyRedirectTimer()
  }
}
</script>
